import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({providedIn: 'root'})
export class ViewportService {
  elements: HTMLElement[] = [];
  elementsSubjects: ReplaySubject<boolean>[] = [];

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', () => this.checkElements());
      window.addEventListener('resize', () => this.checkElements());
      this.checkElements();
    }
  }

  track(element: HTMLElement): Observable<boolean> {
    const index = this.elements.length;
    this.elements.push(element);
    this.elementsSubjects[index] = new ReplaySubject<boolean>(1);
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.elementsSubjects[index].next(isElementInViewport(element));
      });
    }
    return this.elementsSubjects[index];
  }

  deleteElement(element: HTMLElement): void {
    const index = this.elements.indexOf(element);
    if (index > -1) {
      this.elements.splice(index, 1);
      this.elementsSubjects[index].complete();
      this.elementsSubjects.splice(index, 1);
    }
  }

  private checkElements(): void {
    this.elements.forEach((element, index) => {
      this.elementsSubjects[index].next(isElementInViewport(element));
    });
  }
}

function isElementInViewport(element: HTMLElement): boolean {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.top < (window.innerHeight || document.documentElement.clientHeight)
  );
}
